import { useSite } from '../settings'

/** The one sentence that says what each tool answers: on its card on the landing page and at the top of its page. */
export const BLURB = {
  calculator: 'What will my workload cost, and where is the break-even?',
  compare: 'Who sells this model, where, and at what price?',
  fit: 'Which GPU instance or cluster can actually hold it?',
  chat: 'Plain-language questions, answered only from the price data.',
} as const

/** The bold title of a tool's page: on Opex the question the tool answers, elsewhere the usual title. */
export function usePageTitle(id: keyof typeof BLURB, fallback: string): string {
  return useSite().features.question_titles ? BLURB[id] : fallback
}
